export default "__VITE_ASSET__BJdMhwKy__"